module.exports = __webpack_public_path__ + "static/media/dcard_give.26297e06.webp";